import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { AlcolockDisplayModel } from '../../models/alcolock.model';
import { AlcolockService } from '../../services/alcolock.service';
import { Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-alcolock',
  standalone: false,
  templateUrl: './alcolock.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './alcolock.component.scss'
})
export class AlcolockComponent implements OnDestroy {
  testResults: AlcolockDisplayModel[] = [];
  selectedTimeRange = 24;
  isLoading = false;
  isRowLoading = false;
  selectedId: string | null = null;
  private destroy$ = new Subject<void>();

  constructor(private alcolockService: AlcolockService) {}

  ngOnInit(): void {
    this.loadData();
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isRowSelected(id: string): boolean {
    return this.selectedId === id;
  }

  onRowClick(result: AlcolockDisplayModel): void {
    if (this.selectedId === result.id) {
      this.selectedId = null;
      return;
    }

    this.selectedId = result.id;
    if (
      result.firstName &&
      result.lastName &&
      result.department &&
      result.isTrainDriver !== undefined &&
      result.isTrainDriver !== null
    ) {
      return;
    }

    this.isRowLoading = true;
    this.alcolockService.getComplianceById(result.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (full) => {
          const idx = this.testResults.findIndex(r => r.id === result.id);
          if (idx !== -1 && full && full.user) {
            this.testResults[idx] = {
              ...this.testResults[idx],
              firstName: full.user.firstName,
              lastName: full.user.lastName,
              employeeName: `${full.user.firstName} ${full.user.lastName}`,
              email: full.user.email,
              isTrainDriver: full.user.isTrainDriver,
              department: full.user.department
            };
          }
          this.isRowLoading = false;
        },
        error: () => {
          this.isRowLoading = false;
        }
      });
  }

  onTimeRangeChange(): void {
    this.alcolockService.clearCache();
    this.loadData();
  }

  loadData(): void {
    this.isLoading = true;
    this.alcolockService.getTestResultsInTimeRange(this.selectedTimeRange, false)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (results) => {
          this.testResults = results;
          this.isLoading = false;
          this.selectedId = null;
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }


  formatTimestamp(timestamp: string): string {
    return this.alcolockService.formatTimestamp(timestamp);
  }

  getEmployeeName(result: AlcolockDisplayModel): string {
    if (result.firstName && result.lastName) {
      return `${result.firstName} ${result.lastName}`;
    }
    return '';
  }

  get statistics() {
    return this.alcolockService.calculateStatistics(this.testResults);
  }

}
